import Rail from '../../../shared/classes/rail';
import Main from '../../../shared/types/enums/main';
import TMain from '../templates/main';
import seriesObservable from '../../../shared/api/series/seriesObservable';
import { Subscription, Observer } from 'rxjs';
import { channelsSelector } from '../../../shared/store/slices/channels.slice';
import { genresSelector } from '../../../shared/store/slices/genres.slice';
import { routerSelector } from '../../../shared/store/slices/router.slice';
import { useAppSelector } from '../../../shared/store/hooks';
import { useEffect, useState } from 'react';
import { userSelector } from '../../../shared/store/slices/user.slice';

function SeriesExtended() {
  const [complete, setComplete] = useState(false);
  const [rails, setRails] = useState<Rail[]>([]);
  const { channelsData } = useAppSelector(channelsSelector);
  const { data: genresData } = useAppSelector(genresSelector);
  const { initialized } = useAppSelector(userSelector);
  const {
    params: { current: currentParams },
  } = useAppSelector(routerSelector);

  useEffect(() => {
    if (complete) return;
    if (currentParams?.rails) {
      setComplete(true);
      return;
    }

    let subscription: Subscription;
    if (initialized && channelsData?.length && genresData?.length) {
      const initialObserver: Observer<{
        data: Rail[];
        type: Main;
      }> = {
        next: (val) => {
          if (val.type === Main.RAILS) {
            setRails(val.data as Rail[]);
          }
        },
        error: () => {
          console.error('Error recovering series');
        },
        complete: () => {
          setComplete(true);
          return null;
        },
      };
      subscription = seriesObservable(
        (currentParams as { id: string })?.id
      ).subscribe(initialObserver as Partial<Observer<unknown>>);
    }
    return () => {
      subscription?.unsubscribe();
    };
  }, [complete, initialized, channelsData, genresData, currentParams]);

  return (
    <TMain
      complete={complete}
      rails={rails}
      sliders={[]}
      startsInMenu={false}
      startsInSlider={true}
    />
  );
}

export default SeriesExtended;
